import React from "react";
import { Col, Container, Row } from "reactstrap";

const Demo = () => {
  return (
    <section className='fadinup' id='home-demo'>
      <Container fluid className='m-width'>
        <Row>
          <Col md={12} className='text-center'>
            <div className='section-title mb-2'>
              <h2>View Landing Page</h2>
              <img src='assets/images/title-line.png' alt='title-line' className='img-fluid' />
            </div>
          </Col>
          <Col lg={6} md={10} className='offset-lg-3 offset-md-1'>
            <p className='demo-description'>Clean and clear designs makes websites differ from others. We've pre-build demo for giving you as much as flexibility in making your site unique.</p>
          </Col>
        </Row>
        <Row className='mt-35 landing-screen-animation'>
          <Col xl={12} lg={12} xs={12} className='text-center'>
            <div>
              <a href={`${process.env.PUBLIC_URL}/home`}>
                <span className='pc-bg'>
                  <span style={{ backgroundImage: "url(assets/images/demo/ltr.jpg)" }} className='img-scroll'></span>
                </span>
              </a>
            </div>
            <h2 className='demo-title'>Home Page</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Demo;
